<template>
  <div class="task-status-request">
    <FontAwesomeIcon v-if="loading" :icon="['fal', 'spinner-third']" spin class="mr-1" />
    <ButtonGroup>
      <ButtonComponent
        class="task-status-request__reject"
        @click="$emit('input', 'reject')"
        :label="$t('rejectRequest')"
        :icon="['fal', 'times']"
      />
      <ButtonComponent
        class="task-status-request__confirm"
        @click="$emit('input', 'undone')"
        :label="$t('confirmRequest')"
        :icon="['fal', 'check']"
      />
    </ButtonGroup>
  </div>
</template>

<script>
import ButtonGroup from '@kvass/button-group'
export default {
  props: {
    promise: Promise,
  },
  watch: {
    promise: {
      handler(val) {
        if (!val) return (this.loading = false)
        this.loading = true
        val.then(() => (this.loading = false)).catch(() => (this.loading = false))
      },
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  components: {
    ButtonGroup,
  },
}
</script>

<style lang="scss">
.task-status-request {
  display: flex;
  align-items: center;

  &__confirm {
    svg {
      color: var(--success);
    }
  }
  &__reject {
    svg {
      color: var(--error);
    }
  }
}
</style>
